import { Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MobileDetectionService } from '../../../../shared/services/mobile-detection.service';
import { APP_STORE_URL, PLAY_STORE_URL } from './store-links.constants';

type StoreKey = 'ios' | 'android';

/**
 * Tela bloqueante exibida em dispositivos móveis: "trava" o uso do site no
 * celular e direciona o usuário a baixar o app nativo (estilo Mercado Livre).
 *
 * Renderizada no shell raiz (CorePage) acima do router-outlet; quando visível,
 * o restante do app nem é montado.
 */
@Component({
    selector: 'mobile-gate',
    templateUrl: './mobile-gate.component.html',
    styleUrl: './mobile-gate.component.scss',
    standalone: true,
    imports: [TranslatePipe],
})
export class MobileGateComponent {
    private readonly _mobileDetection = inject(MobileDetectionService);

    protected readonly appStoreUrl = APP_STORE_URL;
    protected readonly playStoreUrl = PLAY_STORE_URL;

    /** Ordena as lojas colocando a do SO detectado em primeiro. */
    protected readonly stores = computed<StoreKey[]>(() =>
        this._mobileDetection.platform() === 'android' ? ['android', 'ios'] : ['ios', 'android'],
    );
}
